import { useLayoutEffect, useRef, useState } from 'react';

export default function useElementData<T extends HTMLElement = HTMLElement>() {
  const elRef = useRef<T>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const element = elRef.current;
    if (!element) return;

    setHeight(element.getBoundingClientRect().height);

    const observer = new ResizeObserver(([entry]) =>
      setHeight(entry.borderBoxSize[0].blockSize),
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return { elRef, height };
}
